"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class Rule extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'rule';
        this._name = initParams.name;
        this._description = initParams.description;
        this._triggerLogic = initParams.trigger_logic;
        this._throttleDuration = initParams.throttle_duration;
        this._persistent = initParams.persistent;
        this._assetType = initParams.asset_type;
        this._inactiveState = initParams.inactive_state;
        this._alerts = (0, util_1.camelArray)(initParams.alerts);
        this._triggers = (0, util_1.camelArray)(initParams.triggers);
        this._template = initParams.template;
        this.__permission = initParams._permission;
        this._active = initParams.active;
        this._actions = (0, util_1.camelArray)(initParams.actions);
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    setName(value) {
        return this.dataService.updateRule(this.id, { name: value }, this);
    }
    get name() {
        return this._name;
    }
    set description(value) {
        console.error('Do not set objects this way');
    }
    setDescription(value) {
        return this.dataService.updateRule(this.id, { description: value }, this);
    }
    get description() {
        return this._description;
    }
    set triggerLogic(value) {
        console.error('Do not set objects this way');
    }
    setTriggerLogic(value) {
        return this.dataService.updateRule(this.id, { trigger_logic: value }, this);
    }
    get triggerLogic() {
        return this._triggerLogic;
    }
    set throttleDuration(value) {
        console.error('Do not set objects this way');
    }
    setThrottleDuration(value) {
        return this.dataService.updateRule(this.id, { throttle_duration: value }, this);
    }
    get throttleDuration() {
        return this._throttleDuration;
    }
    set persistent(value) {
        console.error('Do not set objects this way');
    }
    setPersistent(value) {
        return this.dataService.updateRule(this.id, { persistent: value }, this);
    }
    get persistent() {
        return this._persistent;
    }
    set assetType(value) {
        console.error('Do not set objects this way');
    }
    setAssetType(value) {
        return this.dataService.updateRule(this.id, { asset_type: value }, this);
    }
    get assetType() {
        return this._assetType;
    }
    set inactiveState(value) {
        console.error('Do not set objects this way');
    }
    setInactiveState(value) {
        return this.dataService.updateRule(this.id, { inactive_state: value }, this);
    }
    get inactiveState() {
        return this._inactiveState;
    }
    set alerts(value) {
        console.error('Do not set objects this way');
    }
    setAlerts(value) {
        return this.dataService.updateRule(this.id, { alerts: (0, util_1.snakeArray)(value) }, this);
    }
    get alerts() {
        return this._alerts;
    }
    set triggers(value) {
        console.error('Do not set objects this way');
    }
    setTriggers(value) {
        return this.dataService.updateRule(this.id, { triggers: (0, util_1.snakeArray)(value) }, this);
    }
    get triggers() {
        return this._triggers;
    }
    set template(value) {
        console.error('Do not set objects this way');
    }
    setTemplate(value) {
        return this.dataService.updateRule(this.id, { template: value }, this);
    }
    get template() {
        return this._template;
    }
    set _permission(value) {
        console.error('Do not set objects this way');
    }
    set_permission(value) {
        return this.dataService.updateRule(this.id, { _permission: value }, this);
    }
    get _permission() {
        return this.__permission;
    }
    set active(value) {
        console.error('Do not set objects this way');
    }
    setActive(value) {
        return this.dataService.updateRule(this.id, { active: value }, this);
    }
    get active() {
        return this._active;
    }
    set actions(value) {
        console.error('Do not set objects this way');
    }
    setActions(value) {
        return this.dataService.updateRule(this.id, { actions: (0, util_1.snakeArray)(value) }, this);
    }
    get actions() {
        return this._actions;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateRule(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
    delete() {
        return this.dataService.deleteRule(this.id, this);
    }
}
exports.default = Rule;
//# sourceMappingURL=rule.js.map